angular.
module("dx.webapp.printing").
constant("DX_SORT_OPTIONS",
	Object.freeze({
		STUDENTS: "students",
		QUESTIONS: "questions",
	})
);
